import { SYSFormField } from "../../../../_ovlclient/src/library/forms/fieldapi"

let didgitFieldTemplate: SYSFormField = {
  schema: {
    defaultValidationOptions: { displayType: "OnlyOutline" },
  },
  type: "text",
  ui: {
    noLabel: true,
    selectIfFocused: true,
    inputMode: "numeric",
  },
}
export let SYSTOTPFields: { [key: string]: SYSFormField } = {
  TOTPDigit1: didgitFieldTemplate,
  TOTPDigit2: didgitFieldTemplate,
  TOTPDigit3: didgitFieldTemplate,
  TOTPDigit4: didgitFieldTemplate,
  TOTPDigit5: didgitFieldTemplate,
  TOTPDigit6: didgitFieldTemplate,
}
